import { render } from "./I18nSwitchProgress.vue?vue&type=template&id=57722422&scoped=true"
import script from "./I18nSwitchProgress.vue?vue&type=script&lang=js"
export * from "./I18nSwitchProgress.vue?vue&type=script&lang=js"

import "./I18nSwitchProgress.vue?vue&type=style&index=0&id=57722422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57722422"],['__file',"src/components/I18nSwitchProgress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57722422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57722422', __exports__)) {
    api.reload('57722422', __exports__)
  }
  
  module.hot.accept("./I18nSwitchProgress.vue?vue&type=template&id=57722422&scoped=true", () => {
    api.rerender('57722422', render)
  })

}


export default __exports__